import React from 'react';

function ProductSlider() {
  const items = [
    { text: 'ECO-FRIENDLY PRODUCTS', color: '#ff6b6b' },
    { text: 'LAPTOP SLEEVES', color: '#4ecdc4' },
    { text: 'DIARIES', color: '#ffe66d' },
    { text: 'PENS', color: '#a8e6cf' },
    { text: 'KEYCHAINS', color: '#ff8b94' },
    { text: 'BACKPACKS', color: '#95e1d3' },
    { text: 'TROLLEYS', color: '#ffd93d' }
  ];

  return (
    <div className="product-slider">
      <div className="slider-track">
        {[...items, ...items].map((item, index) => (
          <React.Fragment key={index}>
            <span>{item.text}</span>
            <span className="star" style={{ color: item.color }}>✦</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default ProductSlider;
